<template>
  <div class="footer difcac mrTop10">
    <div class="footer_warp difcac">
      <div class="fs14 colfff">copy  2021 - 2022</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "foot"
}
</script>

<style scoped>
  .footer{
    border-top: 2px solid #06676F;
    width: 100%;
    height: 11.5rem;
    background: #07838D;
  }
  .footer_warp{
    color: #fff;
    height: 100%;
    width: 77%;
    box-sizing: border-box;
    padding: 0 2rem;
  }
</style>